import { Bytes as ox__Bytes } from "ox";
import { stringToBytes, toBytes } from "../encoding/to-bytes.js";
import { keccak256 } from "./keccak256.js";
const presignMessagePrefix = "\x19Ethereum Signed Message:\n";
/**
 * Ethereum Signed Message hashing
 * @param message - The message to hash, either as a string, a Uint8Array, or an object with a `raw` property containing a Uint8Array.
 * @param to_ - The desired output format of the hash (optional). Defaults to 'hex'.
 * @example
 * ```ts
 * import { hashMessage } from "thirdweb/utils";
 * const hash = hashMessage("hello world");
 * ```
 * @returns The Ethereum Signed Message hash of the message in the specified format.
 * @utils
 */
export function hashMessage(message, to_) {
    const messageBytes = (() => {
        if (typeof message === "string") {
            return stringToBytes(message);
        }
        if (message.raw instanceof Uint8Array) {
            return message.raw;
        }
        return toBytes(message.raw);
    })();
    const prefixBytes = stringToBytes(`${presignMessagePrefix}${messageBytes.length}`);
    return keccak256(ox__Bytes.concat(prefixBytes, messageBytes), to_);
}
//# sourceMappingURL=hashMessage.js.map